export default __webpack_public_path__ + "static/media/rest1.489aedb0.jpg";